import { Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { ToastrService } from 'ngx-toastr';
import { SharedService } from '../../shared/shared.service';
import { LeadSourceService } from './lead-source.service';
import { BehaviorSubject, Subject } from 'rxjs';
import { environment } from '../../../environments/environment';
@Component({
  selector: 'app-lead-source',
  templateUrl: './lead-source.component.html',
  styleUrls: ['./lead-source.component.scss']
})
export class LeadSourceComponent implements OnInit {
  bucketurl = environment.bucketUrl;
  displayedColumns: string[] = ['SNo', 'lead_source', 'lead_source_code', 'status', 'action'];
  public ELEMENT_DATA: any = [];
  dataSource = new MatTableDataSource(this.ELEMENT_DATA);
  isLoading: Subject<boolean> = new Subject<boolean>();
  @ViewChild(MatSort, { static: true })
  sort: MatSort = new MatSort;
  @ViewChild(MatPaginator, { static: true })
  paginator!: MatPaginator;
  leadSourceForm: FormGroup;
  public searchInput = new FormControl("");
  constructor(private toastr: ToastrService, private fb: FormBuilder, private sharedService: SharedService, private leadSourceService: LeadSourceService) {
    this.leadSourceForm = this.fb.group({
      leadSource: ['', Validators.required],
      leadSourceCode: ['', Validators.required],
      status: ['', Validators.required],
      baseLeadSource: ['', Validators.required]
    });
  }

  public isCreate: boolean = false;
  public isEdit: boolean = false;
  public submitted: boolean = false;

  ngOnInit() {
    this.getList();
    this.searchInput.valueChanges.subscribe(() => {
      this.applyFilter();
    });
  }

  get f() { return this.leadSourceForm.controls; }

  add() {
    this.isCreate = true;
  }

  selectedObject: any = {}
  editData(object: any) {
    this.isEdit = true;
    this.selectedObject = object;
    this.leadSourceForm.patchValue({
      baseLeadSource: object.base_lead_source_id,
      leadSource: object.lead_source,
      leadSourceCode: object.lead_source_code,
      status: object.status ? 1 : 0
    })
  }

  back() {
    this.clearForm();
    this.selectedObject = {};
    this.isCreate = false;
    this.isEdit = false;
    this.getList();
  }

  applyFilter() {
    const filterValue = this.searchInput.value ? this.searchInput.value.trim().toLowerCase() : '';
  
    this.dataSource.filterPredicate = (data: any, filter: string) => {
      const lead_source = data.lead_source.toLowerCase().includes(filter);
      const lead_source_code = data.lead_source_code.toLowerCase().includes(filter);
      return lead_source || lead_source_code;
    };
      this.dataSource.filter = filterValue;
  }

  clearSearch() {
    this.searchInput.setValue('');
    this.applyFilter();
  }

  create() {
    this.submitted = true
    if (this.leadSourceForm.valid) {
      const leadSourceData = this.leadSourceForm.value;
      let obj = {
        "lead_source": leadSourceData.leadSource,
        "lead_source_code": leadSourceData.leadSourceCode,
        "status": parseInt(leadSourceData.status),
        "base_lead_source_id": leadSourceData.baseLeadSource,
        "flag": "create"
      }
      this.isLoading = new BehaviorSubject<boolean>(true);
      this.leadSourceService.leadSourceCrud(obj).subscribe((response: any) => {
        let responseData = response.body;
        if (responseData.responseCode == 200) {
          this.isLoading = new BehaviorSubject<boolean>(false);
          this.toastr.success("Lead source created successfully!")
          this.back();
        } else {
          this.isLoading = new BehaviorSubject<boolean>(false);
          this.toastr.error(responseData.responseMessage)
        }
      }, (err) => {
        this.isLoading = new BehaviorSubject<boolean>(false);
        this.toastr.error(err)
      });
    }
  }

  update() {
    this.submitted = true
    if (this.leadSourceForm.valid) {
      const leadSourceData = this.leadSourceForm.value;
      let obj = {
        "lead_source": leadSourceData.leadSource,
        "lead_source_code": leadSourceData.leadSourceCode,
        "status": parseInt(leadSourceData.status),
        "base_lead_source_id": leadSourceData.baseLeadSource,
        "flag": "update",
        "id": this.selectedObject.id
      }
      this.isLoading = new BehaviorSubject<boolean>(true);
      this.leadSourceService.leadSourceCrud(obj).subscribe((response: any) => {
        let responseData = response.body;
        if (responseData.responseCode == 200) {
          this.isLoading = new BehaviorSubject<boolean>(false);
          this.toastr.success("Lead source updated successfully!")
          this.back();
        } else {
          this.isLoading = new BehaviorSubject<boolean>(false);
          this.toastr.error(responseData.responseMessage)
        }
      }, (err) => {
        this.isLoading = new BehaviorSubject<boolean>(false);
        this.toastr.error(err)
      });
    }
  }

  clearForm() {
    this.submitted = false;
    this.leadSourceForm.patchValue({
      leadSource: '',
      status: ''
    });
  }

  allowAplhabetsOnly(event: any) {
    this.sharedService.allowAlphabetsOnly(event);
  }

  allowAplhabetsNumbersOnly(event: any) {
    this.sharedService.allowAlphabetsAndNumbers(event);
  }

  getList() {
    let reqObject = {
      flag: 'list'
    }
    this.isLoading = new BehaviorSubject<boolean>(true);
    this.leadSourceService.leadSourceCrud(reqObject).subscribe((response: any) => {
      let responseData = response.body
      if (responseData.responseCode == 200) {
        this.isLoading = new BehaviorSubject<boolean>(false);
        this.ELEMENT_DATA = responseData.data
        this.dataSource = new MatTableDataSource(this.ELEMENT_DATA);
        this.dataSource.sort = this.sort;
        this.dataSource.paginator = this.paginator;
      } else {
        this.isLoading = new BehaviorSubject<boolean>(false);
      }
    }, (err) => {
      this.isLoading = new BehaviorSubject<boolean>(false);
    });
  }
}
